<ion-button size="small" [color]="buttonColor" (click)="onClick()" fill="outline">
  <ion-icon *ngIf="!buttonText" slot="icon-only" [name]="buttonIcon"></ion-icon>
  <ion-icon *ngIf="!!buttonText" [name]="buttonIcon"></ion-icon>
  {{ buttonText }}
</ion-button>
